export const appName = 'marketing';
